import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, ShieldCheck, AlertCircle } from "lucide-react";
import { connectStatus } from "../lib/api";
import { getStoredEmail } from "../lib/useNewsezeUser";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Payouts() {
  const [search] = useSearchParams();
  const status = search.get("status");
  const email = getStoredEmail();
  const [acct, setAcct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!email) { setLoading(false); return; }
    connectStatus(email).then((r) => setAcct(r)).catch(() => {}).finally(() => setLoading(false));
  }, [email]);

  const ready = acct?.ready;

  return (
    <>
      <Header onOpenBrief={() => {}} />
      <main className="max-w-[720px] mx-auto px-5 py-14 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[var(--sky)] mb-5">
          {loading ? <Loader2 className="text-[var(--blue)] animate-spin" size={28} />
            : ready ? <ShieldCheck className="text-[var(--blue)]" size={32} />
            : <AlertCircle className="text-[var(--muted)]" size={28} />}
        </div>
        <h1 className="text-[28px] font-black tracking-[-0.02em]" data-testid="payouts-title">
          {loading ? "Checking your account…"
            : ready ? "Your bank is connected. Premium rewards unlocked."
            : status === "complete" ? "Almost there — Stripe is verifying."
            : "Connect your bank to unlock premium rewards."}
        </h1>
        <p className="text-[15px] text-[var(--muted)] mt-3 max-w-[520px] mx-auto">
          {ready
            ? "Future $5 gift-card redemptions will arrive in your inbox within 24 hours."
            : "Open the Redeem panel from your Reader Wallet to start Stripe onboarding."}
        </p>
        <div className="mt-7 flex gap-3 justify-center">
          <Link to="/" className="btn primary" data-testid="payouts-home">Back to Newseze</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
